const features = [
    'Création des plannings et des roulements en 2H',
    'Recherche de remplaçants selon les disponibilités des salariés',
    'Notification instantanée des absences et des modifications de planning',
    'Suivi automatique des heures pour les éléments variables de paie',
    "Modèles de contrats de travail et d'intérim avec signature électronique",
    'Vérification en temps réel de la conformité des plannings',
]

export default features
